export default __webpack_public_path__ + "static/media/schedule-route-exception--red.0873ffc8.svg";